import { render, staticRenderFns } from "./switchList.vue?vue&type=template&id=72e591e0&scoped=true"
import script from "./switchList.vue?vue&type=script&lang=js"
export * from "./switchList.vue?vue&type=script&lang=js"
import style0 from "./switchList.vue?vue&type=style&index=0&id=72e591e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e591e0",
  null
  
)

export default component.exports